import { Box, Menu, MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import wb from '../images/markets/wb.png';
import yandex from '../images/markets/yandex.png';
import ozone from '../images/markets/ozon.png';
import consum from '../images/markets/consum.png';
import { useDispatch, useSelector } from "react-redux";
import { MarketClientSelector, onChangeMarketClient } from "store/slices/marketClient";
// @ts-ignore
import StoreIcon from '@mui/icons-material/Store';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import HomeIcon from '@mui/icons-material/Home';
import { get, getFile } from "api/apiBridges/httpBridge";
import Loading from "./Load";
import useOn from "./socketLib/UseOn";

export function ImgMagazine({ magazine, size, user_id = undefined }) {

    const [loading, setLoading] = useState(user_id? true: false);
    const [CMI, setCMI] = useState(undefined);

    useEffect(() => {

        const fetchData = async () => {
                try {
                setLoading(true);
                const responseData = await get('Clients/get', {cid:user_id});
                if (responseData?.message) {
                  let marketPhoto = undefined
                  if (responseData.message.data) {
                    let clidata = JSON.parse(responseData.message.data)
                    // marketPhoto = clidata?.marketPhoto
                    let img = await getFile("png", { path:clidata?.marketPhoto });
                    if (typeof img === "string") {
                        marketPhoto = img
                    }
                  }
                  
                  setCMI(marketPhoto)
                }
                } catch (err) {
                } finally {
                    setLoading(false);
                }
            };
        
        fetchData();
        
    },[user_id])

    useOn('setMarketIcon', async (data) => {
        if (data?.user_id === user_id ) {
            let photo = undefined;
            if (data.path) {
                photo = await getFile("png", { path:data.path })
                setCMI(photo)
            }
        }      
    });

    const commonIconStyle = {
    width: size,
    height: size,
    objectFit: 'cover',
    borderRadius: '20%',
    display: 'block'
};

switch (magazine) {
    case 'ozon':
        // @ts-ignore
        return (<img style={commonIconStyle} src={ozone} alt="ozon"></img>);
    case 'wb':
        // @ts-ignore
        return (<img style={commonIconStyle} src={wb} alt="wb"></img>);
    case 'yandex':
        // @ts-ignore
        return (<img style={commonIconStyle} src={yandex} alt="yandex"></img>);
    case 'consum':
        // @ts-ignore
        return (<img style={commonIconStyle} src={consum} alt="consum"></img>);

    case 'custom':
        // return (<img style={{ width: size, height: size }} src={consum}></img>);
        return (
            <>
            {loading?
                <Loading/>
                :
                <>
                    {CMI?
                        <img
                            src={CMI}
                            width={size}
                            height={size}
                            // @ts-ignore
                            style={commonIconStyle}
                            alt="Custom Market Icon"
                        ></img>
                        :
                        <HomeIcon sx={{ width: size, height: size }}/>
                    }
                </>
            }
            </>
        )
    default:
        // Даже дефолтную пустую картинку лучше стилизовать так же
        // @ts-ignore
        return (<img style={commonIconStyle}></img>)
}
}

// Компонент для выбора маркетплейса
// выбранный маркет изменяется в редаксе
export function SelectMarket({markets, user_id = undefined}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const { market } = useSelector(MarketClientSelector);
    const [selMarket, setMarket] = useState('');
    const dispatch = useDispatch();
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ($market) => {
        if ($market){
            setMarket($market);
            console.log("change market  ")
            // изменение в редаксе
            dispatch(onChangeMarketClient({ market: $market }));
            //Изменение в локал сторадж
            localStorage.setItem("market", $market)
        }
        setAnchorEl(null);
    };
    useEffect(() => {
        console.log("market 0", market)
        let $market =  market || localStorage.getItem("market") || markets[0] || ''
        setMarket($market);
        // изменение в редаксе
        dispatch(onChangeMarketClient({ market: $market }));
        //Изменение в локал сторадж
        localStorage.setItem("market", $market)
    },[markets])

    

    return (
        <div> {/* Родитель, который центрирует (например, display: flex, align-items: center) */}
            <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={{
                // marginTop: "-10px",
                mt: "5px",
                paddingTop: "5px",
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                ...(open && {
                    bgcolor: '#F5F9FA',//'background.paper',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    boxShadow: 0,
                    // Чтобы при открытом меню тень не накладывалась поверх меню — оставляем ту же
                    '&:hover': { bgcolor: 'background.paper' },
                }),
                "&:hover": {
                    background: "#f5f5f5"
                }
            }}
            >
            <ImgMagazine magazine={selMarket} size={40} user_id={user_id} />
            
            {/* Иконка всегда в DOM, меняем только видимость */}
            <KeyboardArrowDownIcon
                fontSize="10px"
                sx={{
                    mt: '-5px',              // стрелка почти вплотную к картинке
                    visibility: open ? 'hidden' : 'visible', // резервируем место
                }}
            />
            </Button>

            <Menu
                id="basic-menu1"
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose(undefined)}
                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                slotProps={{
                    paper: {
                    sx: {
                        width: "64px",
                        mt: '-15px',
                        bgcolor: '#F5F9FA',//'background.paper',
                        boxShadow: 'none',
                        // boxShadow: `
                        //     -5px 0 8px -4px rgba(0,0,0,0.15),   /* левая тень */
                        //     5px 0 8px -4px rgba(0,0,0,0.15),    /* правая тень */
                        //     0 5px 8px -4px rgba(0,0,0,0.15)    /* верхняя тень */
                        // `,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                    },
                    },
                }}
            >
            {markets.map((el) => (
                <MenuItem key={el.id} onClick={() => handleClose(el)}>
                <   ImgMagazine magazine={el} size={30} user_id={user_id} />
                </MenuItem>
            ))}
            </Menu>
        </div>
    );
}

export function SelectMarketLocal({markets, market, save, size = 20, user_id = undefined}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selMarket, setMarket] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ($market) => {
        if ($market){
            setMarket($market);
            save($market)
        }
        setAnchorEl(null);
    };
    useEffect(() => {
        setMarket(market || markets[0] || '');
        save(market || markets[0] || '')
    },[markets])
    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            >
                <ImgMagazine magazine={selMarket} size={size} user_id={user_id}></ImgMagazine>
            </Button>
            <Menu
                id="basic-menu1"
                anchorEl={anchorEl}
                open={open}
                onClose={()=>handleClose(undefined)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {markets.map(el=>
                    <MenuItem onClick={()=>handleClose(el)}>
                    <ImgMagazine magazine={el} size={size} user_id={user_id}></ImgMagazine>
                </MenuItem>
                )}
            </Menu>
        </div>
    );
}